import { apiClient } from "api/client";

export async function getServiceListApi(id, type) {
  const { data } = await apiClient.get("/get/service", {
    params: { id, type },
  });
  return Array.isArray(data) ? data : [];
}

export async function getServiceDetailApi(docId) {
  const { data } = await apiClient.get("/get/service/detail", {
    params: { docId },
  });
  if (Array.isArray(data)) return data[0] || null;
  return data;
}

export async function getServiceCountApi(id) {
  const { data } = await apiClient.get("/get/service/count", { params: { id } });
  if (typeof data === "number") return data;
  if (data && typeof data.count === "number") return data.count;
  return 0;
}

export async function createServiceApi(body) {
  const { data } = await apiClient.post("/post/service/create", body);
  return data;
}

export async function deleteServiceApi(docId) {
  const { data } = await apiClient.post("/post/service/delete", { docId });
  return data;
}
